import React, { useEffect } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { ccaa_actions } from '../../store/ccaa_slice';
import { auth_actions } from '../../store/auth_slice';

import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

import {
  Input as AntInput,
} from 'antd';


import {
    Flex,
    Box,
    FormControl,
    FormLabel,
    Input,
    Stack,
    Link,
    Button,
    Heading,
    Text,
    useColorModeValue,
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
    Spinner,
    Select
  } from '@chakra-ui/react';

function AdminLogin() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loginError, setLoginError] = React.useState(false);
    const [username, setUsername] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [requestPosted, setRequestPosted] = React.useState(false);
    const [passwordVisible, setPasswordVisible] = React.useState(false);


    const handle_login_submit =async (e) => {
        e.preventDefault();
        setRequestPosted(true);
        sessionStorage.setItem('form_posted',false)
        setIsLoading(true);
        if(username && password){
          dispatch(ccaa_actions.set_logout_action(false));
          try {
            sessionStorage.setItem('user_name', username.toLowerCase());
             const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/jwt-auth/v1/token', {
               "username": username,
               "password": password
             });
            sessionStorage.setItem('token', response.data.token);
             handleAdmin();
             //navigate('/Home');
         }
         catch (error) {
             setRequestPosted(false);
             setLoginError(true);
         }
        }
      }

    const handleAdmin = async () => {
      try{
        ////console.log('admin user handle admin', username);
        const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/monarch_admin/v1/monarch_admin_id', {
          "user_email": username,
        });
        ////console.log('admin res', response.data);
        if(response.data.length > 0){
          sessionStorage.setItem('admin_user_id', response.data[0].user_name);
          dispatch(auth_actions.set_admin_user(true));
          dispatch(auth_actions.set_admin_id(response.data));
        }
        setRequestPosted(false);
        setLoginError(false);
        navigate('/AdminHome');
      }
      catch(error){
        ////console.log(error);
      }
    }


    const handleEnter = (e) => {
      //function to handle the login using enter key
      if(e.key === 'Enter'){
            handle_login_submit(e);
        }
    }

    useEffect(() => {
        sessionStorage.setItem('login_page',true)
        ////console.log('reset auth slice')
        dispatch(auth_actions.reset_auth_slice());
    }, []);

  return (
    <div>
        <Flex
          minH={'100vh'}
          align={'center'}
          justify={'center'}
          bg={useColorModeValue('gray.50', 'gray.800')}>
          <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
            <Stack align={'center'}>
              <Heading fontSize={'4xl'}>Sign in to your account</Heading>
              <Text fontSize={'lg'} color={'gray.600'}>
                Use the same credentials as the ROWHWG website
              </Text>
            </Stack>
            <Box
              rounded={'lg'}
              bg={useColorModeValue('white', 'gray.700')}
              boxShadow={'lg'}
              p={8}>
              <Stack spacing={4}>
                <FormControl id="email">
                  <FormLabel>Email address</FormLabel>
                  <Input type="email"
                    placeholder="Enter email"
                    onChange={(e) => {
                        setUsername(e.target.value);
                    }}
                  />
                </FormControl>
                <FormControl id="password">
                  <FormLabel>Password</FormLabel>
                  <AntInput.Password
                    id="login_password"
                    placeholder="Enter Password"
                    size="large"
                    iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    onChange={(e) => {
                        setPassword(e.target.value);
                    }}
                    onKeyDown={handleEnter}
                  />
                </FormControl>
                <Stack spacing={15}>
                  <Stack
                      direction={{ base: 'column', sm: 'row' }}
                      align={'start'}
                      justify={'space-between'}>
                      <Link href='https://rightofway.erc.uic.edu/wp-login.php?action=lostpassword' color={'blue.400'} isExternal>Forgot Password?</Link>
                    </Stack>
                  <Stack
                    direction={{ base: 'column', sm: 'row' }}
                    align={'start'}
                    justify={'space-between'}>
                      <Text>Don't have an account?</Text>
                    <Link href='https://rightofway.erc.uic.edu/register/' color={'blue.400'} isExternal>Register here</Link>
                  </Stack>
                  <Button
                    id='login_btn'
                    bg={'blue.400'}
                    color={'white'}
                    _hover={{
                      bg: 'blue.500',
                    }}
                    onClick={handle_login_submit}
                    onKeyDownCapture={handleEnter}
                    >
                    Sign in
                  </Button>
                  {isLoading && requestPosted ? (<div className='row'>
                    <div className='col-md-6'>
                      <Text fontSize={'md'} color={'gray.600'}>Logging In</Text>
                    </div>
                    <div className='col-md-6'>
                      <Spinner />
                    </div>
                  </div>): null}
                  {loginError && <Alert status='error'>
                    <AlertIcon />
                    <AlertTitle>Invalid Credentials!</AlertTitle>
                    <AlertDescription>Please check your username and Password.</AlertDescription>
                    </Alert>}
                </Stack>
              </Stack>
            </Box>
          </Stack>
        </Flex>

    </div>
  )
}

export default AdminLogin